import { z } from 'zod';

export const ReconciliationAIMatchSchema = z.object({
  matches: z.array(
    z.object({
      candidateId: z.string(),
      candidateType: z.enum(['AP_PAYMENT', 'AP_BILL', 'FISCAL_DOC']),
      confidence: z.number().min(0).max(1),
      reasoning: z.string(),
      scenarioType: z
        .enum([
          'SIMPLE_1_TO_1',
          'MARKETPLACE_N_TO_1',
          'FUEL_CARD_N_TO_1',
          'INSTALLMENT_WITH_IOF',
          'PARTIAL_PAYMENT',
          'N_TO_N_COMPLEX',
        ])
        .nullable(),
      suggestedAdjustments: z.array(
        z.object({
          type: z.enum(['JUROS', 'MULTA', 'DESCONTO', 'IOF', 'TARIFA', 'VARIACAO_CAMBIAL']),
          amount: z.number(),
          description: z.string(),
        }),
      ),
    }),
  ),
  overallConfidence: z.number().min(0).max(1),
  recommendation: z.enum(['AUTO_LINK', 'MANUAL_REVIEW', 'CREATE_NEW', 'SPLIT_TRANSACTION']),
  reasoning: z.string(),
  complexScenarioDetected: z.boolean(),
  metadata: z.object({
    model: z.string(),
    processingTime: z.number(),
    featuresUsed: z.array(z.string()),
  }),
});

export type ReconciliationAIMatch = z.infer<typeof ReconciliationAIMatchSchema>;

export interface ReconciliationMatchingInput {
  transaction: {
    id: string;
    amount: number;
    postedAt: string;
    description: string;
    counterpartyName?: string;
    counterpartyDocument?: string;
    paymentMethod?: string;
    referenceCode?: string;
  };
  candidates: {
    id: string;
    type: 'AP_PAYMENT' | 'AP_BILL' | 'FISCAL_DOC';
    amount: number;
    date: string;
    description: string;
    vendorDocument?: string;
    metadata?: Record<string, unknown>;
  }[];
  historicalPatterns?: {
    patternId: string;
    description: string;
    successRate: number;
    usageCount: number;
  }[];
  fiscalDocuments?: {
    id: string;
    issuerDocument: string;
    totalAmount: number;
    issueDate: string;
    docType: string;
  }[];
  contextData?: {
    isMarketplace?: boolean;
    isFuelCard?: boolean;
    hasInstallments?: boolean;
    installmentInfo?: {
      current: number;
      total: number;
    };
  };
}
